import {Grid} from '@mui/material';
import ErrorSvg from 'assets/img/net.svg';
import CustomModal from './CustomModal';
import {useEffect, useState} from 'react';

const styles = {
  btnStyle: {
    mt: '48px',
    mb: '7px',
    width: '232px ',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'dana-bold',
    background: '#F5F5F5',
    border: '1px solid #FFFFFF',
    boxShadow:
      '4px 4px 15px rgba(172, 172, 172, 0.5), -4px -4px 15px #FFFFFF !important',
    borderRadius: '16px',
    color: '#753CBE ',
  },
  centerText: {
    width: '100%',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '28px',
    color: '#4D4D4E',
    textAlign: 'center',
  },
  headerText: {
    mb: '40px',
    fontFamily: 'dana-bold',
    fontSize: '14px',
    color: '#D81D5D',
  },
};

export default function NetConnection() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const onlineHandler = () => setIsOnline(true);
    const offlineHandler = () => setIsOnline(false);

    window.addEventListener('online', onlineHandler);
    window.addEventListener('offline', offlineHandler);

    return () => {
      window.removeEventListener('online', onlineHandler);
      window.removeEventListener('offline', offlineHandler);
    };
  }, []);

  return (
    <CustomModal open={!isOnline}>
      <Grid
        container
        xs={12}
        sx={{
          padding: '32px 24px',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <Grid item sx={styles.headerText}>
          <span>اشکال در برقراری ارتباط با شبکه !</span>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            textAlign: 'center',
            mb: '38px',
          }}>
          <img src={ErrorSvg} alt='net-svg' />
        </Grid>
        <p style={styles.centerText}>
          اتصال اینترنت خود را چک کنید و یا از وصل نبودن به وی پی ان اطمینان
          حاصل نمایید.
        </p>
      </Grid>
    </CustomModal>
  );
}
